(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("yox"), require("soga"));
	else if(typeof define === 'function' && define.amd)
		define("bell", ["yox", "soga"], factory);
	else if(typeof exports === 'object')
		exports["bell"] = factory(require("yox"), require("soga"));
	else
		root["bell"] = factory(root["Yox"], root["Soga"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__28__) {
return 